import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

const ClickOnce = ({ onClick, children, ...rest }) => {
  const [clicked, setClicked] = useState(false);
  const onClickOnce = useCallback(
    (...params) => {
      if (clicked) {
        return;
      }
      onClick(...params);
      setClicked(true);
    },
    [onClick, clicked, setClicked],
  );
  return (
    <a onClick={onClickOnce} {...rest}>
      {children}
    </a>
  );
};

ClickOnce.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default ClickOnce;
